import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { gql } from '@apollo/client'
import { taskStatusActionConfigFragment } from '@ztechapps/task.common'

export const assetFragment = gql`
  fragment assetFragment on Asset {
    _id
    url
    title
    subtitle
    thumbUrl
    mediumUrl
    largeUrl
    type
  }
`

export const projectRemarksActivityFragment = gql`
  fragment projectRemarksActivityFragment on Activity {
    _id
    activity
    by {
      _id
      profile {
        _id
        name
        picture
      }
    }
    updatedAt
    isDeleted
  }
`

export const projectTasksFragment = gql`
  fragment projectTasksFragment on Task {
    _id
    name
    code
    remarks
    status
    startDate
    endDate
    timeSpent
    tags
    description
    project {
      _id
      code
      status
      timeSpent
    }
    members {
      _id
      profile {
        _id
        name
        picture
        email
      }
    }
    remarksActivity {
      ...projectRemarksActivityFragment
    }
    subTasks {
      _id
    }
    statusActions {
      ...taskStatusActionConfigFragment
    }
  }
  ${taskStatusActionConfigFragment}
`

export const projectDocumentFragment = gql`
  fragment projectDocumentFragment on Project {
    _id
    tags
    createdAt
    updatedAt
    status
    code
    summary
    name
    timeSpent
    completionDate
    relatedProjects {
      _id
      code
      status
    }
    remarksActivity {
      ...projectRemarksActivityFragment
    }
    tasks {
      ...projectTasksFragment
    }
    progressNow
    progressMax
    relatedWorkOrders {
      _id
      code
      status
    }
    assets {
      ...assetFragment
    }
  }
  ${projectRemarksActivityFragment}
  ${projectTasksFragment}
  ${assetFragment}
`

export const projectListFragment = gql`
  fragment projectListFragment on Project {
    _id
    name
    code
    tags
    remarks
    status
    timeSpent
    completionDate
    createdAt
    progressNow
    progressMax
    remarksActivity {
      ...projectRemarksActivityFragment
    }
  }
  ${projectRemarksActivityFragment}
`

export const projectDocumentQueries = buildGraphqlQuery('Project', projectDocumentFragment, [
  'relatedProjects',
  'remarksActivity',
])
